import { render, staticRenderFns } from "./PelletsComparisonBarWrapper.vue?vue&type=template&id=22862a7c&scoped=true"
import script from "./PelletsComparisonBarWrapper.vue?vue&type=script&lang=ts"
export * from "./PelletsComparisonBarWrapper.vue?vue&type=script&lang=ts"
import style0 from "./PelletsComparisonBarWrapper.vue?vue&type=style&index=0&id=22862a7c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22862a7c",
  null
  
)

export default component.exports